import { render, staticRenderFns } from "./CsInspeccionesIndex.vue?vue&type=template&id=50feaf9b"
import script from "./CsInspeccionesIndex.vue?vue&type=script&lang=js"
export * from "./CsInspeccionesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports